import { Component, Injector, ElementRef } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import {
  BaseResourceFormComponent, Recebimento, LoginPublico,
  GlobalService, DateFormatPipe
} from 'eddydata-lib';
import { RecebimentoService } from '../service/recebimento.service';

@Component({
  selector: 'lib-recebimento-shw',
  templateUrl: './recebimento-shw.component.html'
})
export class RecebimentoShwComponent extends BaseResourceFormComponent<Recebimento, LoginPublico> {

  /**
   * Declaração de variáveis
   */

  public ptBR: any;
  public especie = 'todas';
  public titulo = 'RECEITAS ORÇAMENTÁRIAS';
  private pagina: string;
  private data1: string;
  private data2: string;
  private filtro: string;

  private datepipe: DatePipe;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    private route: ActivatedRoute,
    protected globalService: GlobalService,
    protected recebimentoService: RecebimentoService) {
    super(new Recebimento(), injector, Recebimento.converteJson, recebimentoService);
    this.datepipe = new DatePipe('pt');
    this.route.params.pipe(takeUntil(this.unsubscribe))
      .subscribe(params => {
        this.especie = params['especie'];
        this.pagina = params['pagina'];
        this.data1 = params['data1'];
        this.data2 = params['data2'];
        this.filtro = params['filtro'];
        if (this.especie === 'impostos') {
          this.titulo = 'ARRECADAÇÃO DE IMPOSTOS';
        } else if (this.especie === 'estaduais') {
          this.titulo = 'TRANSFERÊNCIAS ESTADUAIS';
        } else if (this.especie === 'federais') {
          this.titulo = 'TRANSFERÊNCIAS FEDERAIS';
        } else if (this.especie === 'operacoes') {
          this.titulo = 'OPERAÇÕES DE CRÉDITO';
        }
      });
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      guia: [null, [Validators.required]],
      valor_recebido: 0,
      data_recebimento: [null, [Validators.required]],
      data_referencia: [null, [Validators.required]],
      especie: [null, [Validators.required]],
      impresso: [null, [Validators.required]],
      historico: [null, [Validators.required, Validators.minLength(2)]],
      conta: [null, [Validators.required]],
      exercicio: [null],
      orgao: [null, [Validators.required]],
      ficha: [null]
    });
  }

  protected parametrosExtras(): {} {
    return { relations: 'conta,conta.banco,ficha,ficha.receita,ficha.recurso,ficha.aplicacao' };
  }

  protected afterInit(): void {
    this.login.contraste = sessionStorage.getItem('contraste') === 'true';

  }

  protected campoFoco(): ElementRef {
    return null;
  }

  protected beforeSubmit(): void {
  }

  protected afterSubmit(entidade: Recebimento): void {
  }

  protected afterLoad() {
    this.entidade.data_recebimento = new DateFormatPipe().transform(this.entidade.data_recebimento, []);
  }

  public voltar() {
    const dt1 = this.datepipe.transform(this.data1, 'yyyy-MM-dd', 'GMT');
    const dt2 = this.datepipe.transform(this.data2, 'yyyy-MM-dd', 'GMT');
    if (!this.filtro || this.filtro === '') {
      this.router.navigate([`/receitas-orcamentarias/pesquisa`, this.especie, this.pagina, dt1, dt2]);
    } else {
      this.router.navigate([`/receitas-orcamentarias/pesquisa`,
      this.especie, this.pagina, dt1, dt2, this.filtro]);
    }
  }
}
